import { SocketMessageMaker } from './SocketMessageMaker'

// class GATSocketTask {
//     constructor(options) {

//     }

//     repeatBy(time) {

//     }
// }

class GATSocket {
  constructor(options) {
    this.url = options.url
    this.components = options.components
    this.messages = options.messages

    this.componentsMap = {}
    this.socket = null
    this.is_connection = false
    this.count = 1
    this.interval = 2000

    this.isOpen = false
    this.onlyGet = false
    this.messageQueue = []

    this.targetCache = {}

    this._initSocket()

    this._reconnectionTimer = null

    this.isClose = false
  }

  _initSocket() {
    try {
      if (this.socket) {
        this.socket.close()
        this.socket = null
      }
    } catch (e) {
      console.log(e)
    }

    this.socket = new WebSocket(this.url)
    this._addListener(this.socket)

    this.addComponents(this.components)
  }

  _addListener(ws) {
    ws.onopen = () => {
      this.isOpen = true
      this.isClose = false
      try {
        // this.login()
        this.messageQueue.length > 0 &&
          this.messageQueue.forEach(message => {
            console.log('已发送缓存消息: ', message)
            this.send(message)
          })
        this.messageQueue = []
        // this.messages && this.messages.forEach(message => {
        //     this.send(message)
        // })
        // for (const key in this.componentsMap.comment) {
        //     console.log('socket断开已经重连，已发送 joinGroup ',key)
        //     this.send({
        //         action: 'joinGroup',
        //         groupId: key
        //     })
        // }
      } catch (e) {
        console.log(e)
      }
    }

    ws.onmessage = e => {
      this.is_connection = true
      const data = JSON.parse(e.data)
      console.log('onmessage:', data)
      if (data.touserid) {
        const target = this.componentsMap[data.touserid]
        for (const key in target) {
          if (Object.hasOwnProperty.call(target, key)) {
            const handler = target[key]
            handler &&
              handler(
                data,
                message => {
                  this.send(message)
                },
                this.leave.bind(this)
              )
          }
        }
      }
    }

    ws.onclose = e => {
      this.isOpen = false
      if (!e.wasClean && !this.isClose) {
        this.is_connection = false
        this._reconnection()
      } else {
        ws = null
      }
    }

    ws.onerror = e => {
      console.log('onerror：', e)
      // this.isOpen = false
      // this.is_connection = false
      // this._reconnection()
      // this.close()
      // this.login()
    }
  }

  _reconnection() {
    this._reconnectionTimer && clearTimeout(this._reconnectionTimer)
    this._reconnectionTimer = setTimeout(() => {
      if (!this.is_connection) {
        if (this.count > 30) return
        this._initSocket()
        this._reconnection()
        this.count++
      } else {
        this.count = 1
      }
    }, parseInt(this.count / 5) * this.interval + this.interval)
  }

  reopen() {
    this._initSocket()
  }

  close() {
    this.isClose = true
    this.socket.close()
  }

  send(message) {
    if (!this.isOpen) {
      console.log('已缓存消息:', message)
      this.messageQueue.push(message)
    } else {
      this.socket.send(JSON.stringify(SocketMessageMaker.make(message)))
    }
  }

  addComponent(component) {
    const { target = 'common', action, handler } = component
    if (!this.componentsMap[action]) this.componentsMap[action] = {}
    if (!this.componentsMap[action][target]) {
      this.componentsMap[action][target] = {}
      if (!this.targetCache[target]) this.targetCache[target] = []
    }
    this.componentsMap[action][target] = handler
    this.targetCache[target].push(component)
  }

  removeComponent(component) {
    const { target = 'common', action } = component
    if (!this.componentsMap[action]) {
      console.error('不存在的action')
      return
    }
    delete this.componentsMap[action][target]
  }

  addComponents(components) {
    components &&
      components.forEach(component => {
        this.addComponent(component)
      })
  }

  removeComponents(components) {
    components &&
      components.forEach(component => {
        this.removeComponent(component)
      })
  }

  // 业务相关
  login(params) {
    this.send({
      action: 'login',
      ...params
    })
  }

  sendMessage(data, components) {
    const { touserid } = data
    try {
      this.addComponents(
        (Array.isArray(components) ? components : [components]).map(component => {
          return {
            target: touserid,
            ...component
          }
        })
      )
      this.send({
        action: 'sendmsg',
        ...data
      })
    } catch (e) {
      console.log(e)
    }
    // for (const key in this.componentsMap.comment) {
    //     console.log(key)
    // }
  }
  getMessage(data, component) {
    const { touserid } = data
    try {
      return this.addComponents({
        target: touserid,
        action: 'common',
        handler() {}
      })
    } catch (e) {
      console.log(e)
    }
  }

  leave(touserid) {
    this.removeComponents(this.targetCache[touserid])
    this.targetCache[touserid] = []
    // this.send({
    //     action: 'leaveGroup',
    //     touserid
    // })
  }
}

GATSocket.MessageMaker = SocketMessageMaker

export default GATSocket
